import React from 'react';
import { TrendingUp, TrendingDown } from 'lucide-react';
import { motion } from 'framer-motion';

const MetricCard = ({ data, config, title }) => {
  if (!data || data.length === 0) {
    return <div className="text-sand-700 p-8 text-center">No data available</div>;
  }

  const valueKey = config?.valueKey || Object.keys(data[0])[0];
  const value = Number(data[0][valueKey]) || 0;
  const previousValue = data.length > 1 ? Number(data[1][valueKey]) || 0 : value;
  const change = previousValue !== 0 ? ((value - previousValue) / previousValue) * 100 : 0;
  const isPositive = change >= 0;

  return (
    <motion.div
      initial={{ opacity: 0, scale: 0.9 }}
      animate={{ opacity: 1, scale: 1 }}
      className="bg-white border border-[rgba(32,30,29,0.12)] rounded-xl p-6 shadow-brand-sm"
    >
      <p className="text-sand-600 text-sm mb-2">{title || 'Metric'}</p>
      <div className="flex items-end justify-between">
        <div>
          <p className="text-4xl font-bold text-ink tnum">{value.toLocaleString()}</p>
          <p className={`text-sm mt-2 flex items-center gap-1 ${isPositive ? 'text-sage-600' : 'text-red-600'}`}>
            {isPositive ? <TrendingUp className="w-4 h-4" /> : <TrendingDown className="w-4 h-4" />}
            {Math.abs(change).toFixed(1)}%
          </p>
        </div>
      </div>
    </motion.div>
  );
};

export default MetricCard;
